import { createGlobalStyle } from 'styled-components';

const LightTheme = createGlobalStyle`
  body {
    // primary colors
    --primary: #0c5787; // not used (?)
    --primaryDark: #0c5787;
    --secondary: #80C0E9;
    --black: #262626;;
    // Grey colors
    --grey: #6B8799;
    --greyLight: #E6EEF2;
    // Status colors
    --warning: #E1B04F;
    --success: #36b395;
    // Text colors
    --textGrey: #6B8799;
    // BG colors
    --bg-light-1: #EBF3FA;
    // Stoke colors
    --strokeLight: #D6E8F5;
        
    --textColorSecondary: #FAFAFA;
    --textColor: #0C5787;
    --clientColor: #0C5787;
    --primaryColor: #80C0E9;
    --addColor: #439167;
    --itemHoverColor: var(--primaryColor);
    --componentBackground: #fff;
    --secondaryHover: var(--componentBackground);
    --subMenuBackground: var(--componentBackground);
    --menuDropdownBackground: var(--componentBackground);
    --pickerDropdown: var(--componentBackground);
    --primaryHover: var(--primaryColor);
    --secondaryColor: rgb(181, 16, 16);
    --disabledColor: #a5a3a3;
    --bodyBackground: #FAFAFA;
    --itemActiveBackground;
    --itemHoverBackground: #f0f0f0;
    --borderColor: #CBD1D4;
    --contrastBackground: var(--componentBackground);
    --opacitySVG: 1;
    --textColorA015: #333333;
    --primaryColorA04
    --primaryColorA07
    --primaryContrast
    --tabsGray
    --textColorInvert
    --textColorHover
    --textColorA075
    --borderColorA06
    --disabledColorA04
    --disabledColorA06
    --itemActiveColor
    --logo
    --logoSmall
    --errorColor: '#B51010',
    --error100: '#B51010',
    --errorA08: '#B51010',
  }
`;

export default LightTheme;
